import { useEffect, useState } from "react";

// True once the launch splash (#app-splash) is gone. Starts `true` right away
// if the splash was already removed before this mounted (e.g. Home reached
// via internal SPA navigation, not a fresh page load) — otherwise waits for
// useHideSplashScreen's one-time "infocity:splash-hidden" event.
export function useSplashHidden() {
  const [hidden, setHidden] = useState(() => !document.getElementById("app-splash"));

  useEffect(() => {
    if (hidden) return;
    const onHidden = () => setHidden(true);
    window.addEventListener("infocity:splash-hidden", onHidden);
    return () => window.removeEventListener("infocity:splash-hidden", onHidden);
  }, [hidden]);

  return hidden;
}
